import { axios } from "~/plugins/request";

export const state = () => {
  return {};
};
export const mutations = {};
export const actions = {
  findAllCard({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`searchCard/findAllCard`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  findAll({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`searchCard/findAll`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  export({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`searchCard/export`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  findTotalCard({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`searchCard/findTotalCard`, { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  findResumeCard({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`searchCard/findResumeCard`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  saveHairpinResumeConversion({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`searchCard/saveHairpinResumeConversion`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  exportHairpinResume({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`searchCard/exportHairpinResume`, { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getHaveCount({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`searchCard/getHaveCount`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  invalidCardNums({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`searchCard/invalidCardNums`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  findCardUsageRecord({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`searchCard/findCardUsageRecord`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  changeCardStatus({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`searchCard/changeCardStatus`, { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  editTermValidity({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`searchCard/editTermValidity`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};
